const formUrls: Record<string, string> = {
  contact: "https://readdy.ai/api/form/d9qodfee3oq4jqumtnv0",
};

export async function getFormUrl(formType: string) {
  return {
    submitAddr: formUrls[formType] || "",
  };
}